/**
 * 66.7 (a), IDEAS X32: taking cover, the player's side — what the HUD reads of it (decision 144: the cover system first).
 * Shift snaps you to a rock, trunk, ruin or wall edge (game/takeCover.ts); you lean out round an edge or rise over a low
 * one to fire, and move away to leave. The cover you are in (`CoverHeld`): the side you fire from (`left` / `right`
 * round an edge, `over` a low one) and whether you are out of it now (peeking: exposed).
 *
 * The owner, playing it (Oct 11): "the commands aren't great, need to get rid of the 'shift to cover' thing in the middle
 * as it's annoying and messing up aim and sensitivity" — so no prompt in the middle (Shift just works when cover is in
 * reach; the keys card has it) and the camera keeps its shoulder (it used to swap to the cover's open side and lean out
 * with a peek, moving the view under the mouse). What is left is the crosshair's small bracket on the cover's side.
 *
 * Pure. Presentation only.
 */

/** The side you fire from in cover: round its left or right edge, or over it (it is lower than your eye standing). */
export type CoverSide = 'left' | 'right' | 'over';

/** The cover you are in. */
export interface CoverHeld { side: CoverSide; peeking: boolean }

/** The crosshair's cue in cover: where the cover is against the crosshair, and whether you are out of it. */
export interface CoverMark { side: CoverSide; exposed: boolean }

/** The crosshair's cue: the cover's side and whether you are out of it (null: not in cover). */
export function coverMark(held: CoverHeld | null): CoverMark | null {
  return held ? { side: held.side, exposed: held.peeking } : null;
}
